module.exports = __webpack_public_path__ + "static/media/ic-empty-logo.c96a80e8.svg";